import { Listbox } from '@headlessui/react';

import { classNames } from '~/lib';
import { ChevronDown } from '../Icons';

interface MobileCategoryNavProps {
  category?: string;
  setCategory?: (string) => void;
  categories?: string[];
}

export const MobileCategoryNav = ({
  category,
  setCategory,
  categories,
}: MobileCategoryNavProps) => {
  return (
    <Listbox value={category} onChange={setCategory}>
      {({ open }) => (
        <>
          <Listbox.Button
            className={classNames(
              'w-full px-4 py-3 text-grey-700 border border-yellow-500 rounded-md shadow-sm flex justify-between items-center',
              open && 'outline outline-4 outline-yellow-50',
            )}
          >
            <div>{category === 'all' ? 'View all' : category}</div>
            <ChevronDown
              className={classNames(
                'w-3 text-grey-500 transition-transform',
                open && 'rotate-180',
              )}
            />
          </Listbox.Button>
          <Listbox.Options className="absolute top-16 z-20 bg-white w-full shadow-md rounded-md text-grey-700 border border-grey-100">
            <div className="py-3 px-4 font-medium border-b">
              Pick a category
            </div>

            <Listbox.Option value={'all'} className="py-3 px-4">
              View all
            </Listbox.Option>
            {categories?.map((cat, i) => (
              <Listbox.Option key={i} value={cat} className="py-3 px-4">
                {cat}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </>
      )}
    </Listbox>
  );
};
